/** Must match `public.is_attempt_scan_status_transition_allowed`. */
export enum AttemptScanStatus {
  Pending = 'pending',
  Reading = 'reading',
  Read = 'read',
  Failed = 'failed',
}

/** What a page of a scan is, as read. Must match `attempt_scan_pages.kind`. */
export enum AttemptScanPageKind {
  ResponseSheet = 'response_sheet',
  RoughWorking = 'rough_working',
  Blank = 'blank',
  Other = 'other',
}

/** The file types the attempt-scans bucket accepts. */
export enum AttemptScanMimeType {
  Pdf = 'application/pdf',
  Png = 'image/png',
  Jpeg = 'image/jpeg',
}
